import React from 'react'
import { CardHeader, Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import LockIconComponent from 'components/UpgradeMembership/LockIconComponent'
import useTeamFeature from 'hooks/useTeamFeature'
import PropTypes from 'prop-types'
import { Heading } from '../../styledComponents'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    border: '1px solid #eee',
    padding: theme.spacing(0, 1, 0),
    borderRadius: 10,
    marginBottom: 4,
    '& .MuiCardHeader-root': {
      padding: 8,
    },
    '& .MuiCardContent-root:last-child': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      '& .MuiCardContent-root': {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
      },
    },
  },
}))

const PlayersListCard = ({ title, children }) => {
  const classes = useStyles()

  const { enabled: hasAdvancedMatchFeaturesEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.advanced_match_features_enable
  )

  return (
    <Card className={classes.root}>
      <CardHeader
        title={
          <Heading variant="h4" component="h4">
            {title}{' '}
            {!hasAdvancedMatchFeaturesEnabled ? (
              <LockIconComponent context="primaryButton" />
            ) : null}
          </Heading>
        }
      />
      <CardContent>{children}</CardContent>
    </Card>
  )
}
PlayersListCard.defaultProps = {
  title: '',
}

PlayersListCard.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
}
export default PlayersListCard
